var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.5,
    height: 128.5,
    viewBox: "0 0 128.5 128.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13121",
    "data-name": "Group 13121",
    transform: "translate(-1678.75 -1479.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M40.187,2a64,64,0,1,0,64,64A64.073,64.073,0,0,0,40.187,2Zm0,115.2A51.2,51.2,0,1,1,91.387,66,51.26,51.26,0,0,1,40.187,117.2Z",
    transform: "translate(1702.813 1478)",
    fill: "#333",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13120",
    "data-name": "Group 13120",
    transform: "translate(5.65 -5.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-8.959,18.641a5.822,5.822,0,0,0,5.82-5.82A5.822,5.822,0,0,0-8.959,7h-.058a5.8,5.8,0,0,0-5.791,5.82A5.844,5.844,0,0,0-8.959,18.641Z",
    transform: "translate(1746.368 1513.568)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1.648,34.281V16.82A5.822,5.822,0,0,0-4.172,11h-5.82a5.822,5.822,0,0,0-5.82,5.82,5.819,5.819,0,0,0,5.82,5.82V40.1a5.819,5.819,0,0,0,5.82,5.82h5.82a5.82,5.82,0,0,0,0-11.641Z",
    transform: "translate(1741.522 1532.852)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.f8c4dfbcf1d8fc8034ea81721b9c7358.svg";
export { ForwardRef as ReactComponent };